export function isFileRef(value) {
    return value && value['@@type'] === 'file';
}
export function createFileRef(id) {
    return {
        '@@type': 'file',
        id,
    };
}
export function getAllFileFields(snapshot) {
    return Object.entries(snapshot).filter((entry) => isFileRef(entry[1]));
}
//# sourceMappingURL=files.js.map